import * as React from 'react'
import { SVGProps, Ref, forwardRef, memo } from 'react'

const SvgMindmap = (
  props: SVGProps<SVGSVGElement>,
  ref: Ref<SVGSVGElement>
) => (
  <svg
    width="1em"
    height="1em"
    viewBox="0 0 1216 1024"
    xmlns="http://www.w3.org/2000/svg"
    ref={ref}
    {...props}
  >
    <path d="M607.424 394.72a128 128 0 1 1 0 256 128 128 0 0 1 0-256zM151.872 39.104a128 128 0 1 1 0 256 128 128 0 0 1 0-256zm0 38.4a89.6 89.6 0 1 0 0 179.2 89.6 89.6 0 0 0 0-179.2zm0 665.6a128 128 0 1 1 0 256 128 128 0 0 1 0-256zm0 38.4a89.6 89.6 0 1 0 0 179.2 89.6 89.6 0 0 0 0-179.2zm0-390.4a128 128 0 1 1 0 256 128 128 0 0 1 0-256zm0 38.4a89.6 89.6 0 1 0 0 179.2 89.6 89.6 0 0 0 0-179.2zm896-390.4a128 128 0 1 1 0 256 128 128 0 0 1 0-256zm0 38.4a89.6 89.6 0 1 0 0 179.2 89.6 89.6 0 0 0 0-179.2zm0 665.6a128 128 0 1 1 0 256 128 128 0 0 1 0-256zm0 38.4a89.6 89.6 0 1 0 0 179.2 89.6 89.6 0 0 0 0-179.2zm0-390.4a128 128 0 1 1 0 256 128 128 0 0 1 0-256zm0 38.4a89.6 89.6 0 1 0 0 179.2 89.6 89.6 0 0 0 0-179.2z" />
    <path d="m280.224 510.144 224.384 5.184a16 16 0 0 1 2.144 31.808l-2.88.192-224.384-5.184a16 16 0 0 1-2.144-31.808l2.88-.192zm639.456 2.592a16 16 0 0 1 3.232 31.712l-2.88.32-233.056 2.56a16 16 0 0 1-3.2-31.68l2.848-.32 233.056-2.56z" />
    <path d="M350.72 160.288c55.456 0 98.912 54.4 101.664 121.216l.128 6.72v475.84c0 67.616-41.664 124.192-96.256 127.776l-5.504.192h-91.776a16 16 0 0 1-2.88-31.744l2.88-.256h91.776c36 0 67.264-39.008 69.632-89.824l.128-6.144v-475.84c0-51.712-29.856-92.672-65.472-95.776l-4.288-.16H255.52a16 16 0 0 1-2.88-31.744l2.88-.256h95.232zm498.624 731.744c-52.576 0-93.152-54.4-95.808-121.024l-.16-6.944v-475.84c0-67.392 38.88-124.064 90.56-127.744l5.408-.192h85.536a16 16 0 0 1 2.88 31.744l-2.88.256h-85.536c-32.576 0-61.536 38.72-63.808 89.536l-.16 6.4v475.84c0 51.776 27.68 92.576 59.904 95.776l4.064.192h88.768a16 16 0 0 1 2.88 31.744l-2.88.256h-88.768z" />
  </svg>
)

const ForwardRef = forwardRef(SvgMindmap)
const Memo = memo(ForwardRef)
export default Memo
